import type { Routes } from '@angular/router';
import { MENU_ITEMS } from './core/data/menu-items';
import { ssoAuthGuard } from './core/guards/sso-auth.guard';
import { ssoCallbackGuard } from './core/guards/sso-callback.guard';

const resolvedRoutes = new Set(['/dashboard', '/market-news', '/data-shooter']);

const placeholderRoutes: Routes = MENU_ITEMS.filter(
  (item) => !item.isExternal && !resolvedRoutes.has(item.route),
).map((item) => ({
  path: item.route.replace(/^\//, ''),
  loadComponent: () =>
    import('./features/page-placeholder/page-placeholder').then((m) => m.PagePlaceholderComponent),
  data: { title: item.label },
}));

export const routes: Routes = [
  {
    path: 'auth/callback',
    canActivate: [ssoCallbackGuard],
    loadComponent: () =>
      import('./core/components/auth-callback/auth-callback').then((m) => m.AuthCallbackComponent),
    data: { title: 'Signing In' },
  },
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  {
    path: '',
    canActivate: [ssoAuthGuard],
    loadComponent: () =>
      import('./core/components/main-layout/main-layout').then((m) => m.MainLayoutComponent),
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./modules/general-overview/components/general-overview-layout/general-overview-layout').then(
            (m) => m.GeneralOverviewLayout,
          ),
        data: { title: 'General Overview' },
      },
      {
        path: 'market-news',
        loadComponent: () =>
          import('./modules/market-news/components/market-news-layout/market-news-layout').then(
            (m) => m.MarketNewsLayout,
          ),
        data: { title: 'Market News & Insight' },
      },
      {
        path: 'data-shooter',
        loadComponent: () =>
          import('./modules/data-shooter/components/data-shooter-layout/data-shooter-layout').then(
            (m) => m.DataShooterLayout,
          ),
        data: { title: 'Data Shooter' },
      },
      {
        path: 'profile',
        loadComponent: () => import('./features/profile/profile').then((m) => m.ProfileComponent),
        data: { title: 'User Profile' },
      },
      ...placeholderRoutes,
    ],
  },

  { path: '**', redirectTo: 'dashboard' },
];
